module.exports = __webpack_public_path__ + "img/3.b6974d20.jpg";